import { Component, Output, OnDestroy, OnInit, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { UsedSzmd036aService } from '../../services/used-szmd036a.service';

import { UsedSzme043aService } from '../../services/used-szme043a.service';
import { Szme043aResponseClaimBasicInf02Dto } from 'sg-api';
import { UsedSgkd051aService } from '../../services/used-sgkd051a.service';
import { Szme037aResponseCdtmnySyosaiRefInfDto } from 'sg-api';
import { UsedSgkd052aService } from '../../services/used-sgkd052a.service';
import { Szme038aResponseCdtmnyMeisaiInfDto } from 'sg-api';
import { Szmd036aResponse, Szme037aResponse, Szme038aResponse, Szme043aResponse, ResponseCommon } from 'sg-api';

/**
 * 売掛金詳細画面
 * @export
 * @class UrikakekinElectricComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'app-urikakekin-electric',
  templateUrl: './sgkd012d.component.html',
  styleUrls: ['./sgkd012d.component.scss']
})
export class Sgkd012dComponent implements OnInit, OnDestroy {

  /** サービス種別コード */
  readonly SRV_CLSFY_CODE = {
    /** ガス */
    GAS: '01',
    /** 電力 */
    ELE: '11',
    /** リース */
    LEASE: '03',
    /** 定額 */
    TEIGAKU: '12',
  } as const;

  /** 前画面から渡された請求お客さま番号 */
  recptFixNoParent: string;
  /** 前画面から渡された売掛金番号 */
  cdtmnyNoParent: string;
  /** 前画面から渡された売掛金履歴番号 */
  cdtmnyRrknoParent: string;
  /** 売掛金情報、契約情報、売掛金詳細 */
  urikakekinInfo: Szme037aResponseCdtmnySyosaiRefInfDto;
  /** 取得日付 */
  targetYmd: string;
  /** 確定情報 */
  fixedInfo: string;
  /** 請求基本情報 */
  billingBasicInfo: Szme043aResponseClaimBasicInf02Dto;
  /** 売掛金詳細（内訳） */
  electricDetailUchiwake: Szme038aResponseCdtmnyMeisaiInfDto[];
  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();
  /** 表示Form */
  electricConditionForm: UntypedFormGroup;
  /** プロダクト種別区分コード */
  prdClsfyDiv: string;

  /** 契約容量 */
  conCapKva: string    

  /** 契約容量単位 */
  conCapKvaUnit: string

  /** 画面表示フラグ */
  displayFlgSzme043: boolean = false;
  /** 画面表示フラグ */
  displayFlgSzme037: boolean = false;
  /** 画面表示フラグ */
  displayFlgSzme038: boolean = false;

  /** 売掛金料金結果確定情報取得結果 */
  szmd036aResponse: Szmd036aResponse;
  /** 売掛金詳細照会結果 */
  szme037aResponse: Szme037aResponse;
  /** 売掛金詳細照会明細 */
  szme038aResponse: Szme038aResponse;
  /** 請求基本情報取得結果 */
  szme043aResponse: Szme043aResponse;
  /** responseCommon */
  szmd036aResponseCommon: ResponseCommon;
  /** responseCommon */
  sgkd051aResponseCommon: ResponseCommon;
  /** responseCommon */
  szme038aResponseCommon: ResponseCommon;
  /** responseCommon */
  szme043aResponseCommon: ResponseCommon;
  sgkd051aResponse: import("sg-api").Sgkd051aResponse;

  /**
   * コンストラクタ
   * @param {ActivatedRoute} route
   * @memberof UrikakekinElectricComponent
   */
  constructor(private fb: UntypedFormBuilder, private router: Router, private route: ActivatedRoute,
    private usedSzmd036aService: UsedSzmd036aService, private usedSzme043aService: UsedSzme043aService,
    private usedSgkd051aService: UsedSgkd051aService, private usedSgkd052aService: UsedSgkd052aService) {
    // 親画面から渡された請求お客さま番号を取得
    this.recptFixNoParent = this.route.snapshot.paramMap.get('recptFixNo');
    // 親画面から売掛金番号を取得
    this.cdtmnyNoParent = this.route.snapshot.paramMap.get('cdtmnyNo');
    // 親画面から売掛金履歴番号を取得
    this.cdtmnyRrknoParent = this.route.snapshot.paramMap.get('cdtmnyRrkno');

    this.electricConditionForm = this.fb.group({
      requestCommon: new UntypedFormGroup({}),
    });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  /**
     * 初期処理
     * @memberof UrikakekinElectricComponent
     */
  ngOnInit(): void {

    // 受信データの購読設定（売掛金情報、契約情報、売掛金詳細）
    this.usedSgkd051aService.contractorValueChanges
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(sgkd051aResponse => {
        this.sgkd051aResponse = sgkd051aResponse;
        this.sgkd051aResponseCommon = sgkd051aResponse.responseCommon
        this.urikakekinInfo = sgkd051aResponse.responseDto.szme037AResponse.cdtmnySyosaiRefInfDto;
        this.conCapKva = sgkd051aResponse.responseDto.conCapKva;
        this.conCapKvaUnit = sgkd051aResponse.responseDto.conCapKvaUnit;
        this.prdClsfyDiv = sgkd051aResponse.responseDto.prdClsfyDiv
      });
    this.usedSzmd036aService.contractorValueChanges
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(szmd036aResponse => {
        this.szmd036aResponse = szmd036aResponse;
        this.szmd036aResponseCommon = szmd036aResponse.responseCommon
        this.fixedInfo = szmd036aResponse.fixedInfo;
        this.targetYmd = null;
      });
    // 売掛金情報を取得
    this.getUrikakekinInfo();

    // 受信データの購読設定（請求基本情報）
    this.usedSzme043aService.contractorValueChanges
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(szme043aResponse => {
        this.szme043aResponse = szme043aResponse;
        this.szme043aResponseCommon = szme043aResponse.responseCommon
        this.billingBasicInfo = szme043aResponse.claimBasicInf02Dto;
      });
    // 請求基本情報を取得
    this.getBillingBasicInfo();

    // 受信データの購読設定（売掛金詳細（内訳））
    this.usedSgkd052aService.contractorValueChanges
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(szme038aResponse => {
        this.szme038aResponse = szme038aResponse;
        this.szme038aResponseCommon = szme038aResponse.responseCommon
        this.electricDetailUchiwake = szme038aResponse.cdtmnySyosaiRefMeisaiInfDto.cdtmnyMeisaiInfDto;
      });
    // 売掛金詳細（内訳）を取得
    this.getElectricDetailUchiwake();

  }

  /**
 * 延滞利息照会ボタン押下時の処理
 * @memberof UrikakekinElectricComponent
 */
  onClick(): void {
    this.router.navigate(['/sgkd/sgkd011d/', { 'cdtmnyNo': this.cdtmnyNoParent || "" }]);
  }

  /**
   *  売掛金詳細照会APIを呼び出す
   *
   * @memberof UrikakekinElectricComponent
   */
  getUrikakekinInfo(): void {
    // 売掛金詳細照会API呼び出し
    this.usedSgkd051aService.searchContractor(this.electricConditionForm.getRawValue(),
      this.cdtmnyNoParent, this.cdtmnyRrknoParent).subscribe(response => {
        console.log(response);
        this.displayFlgSzme037 = true;
        this.targetYmd = response.responseDto.szme037AResponse.cdtmnySyosaiRefInfDto.cdtmnySyosaiInfDto.calcEndDate;

        if (this.targetYmd != null) {
          // 「利用期間（終了）」≠NULLの場合に確定情報を取得
          this.usedSzmd036aService.searchContractor(
            this.cdtmnyNoParent, this.cdtmnyRrknoParent, this.targetYmd).subscribe(response => {
              console.log(response);
              this.fixedInfo = response.fixedInfo;
            });
        }
      });
  }

  /**
   * 請求基本情報取得APIを呼び出す
   *
   * @memberof UrikakekinElectricComponent
   */
  getBillingBasicInfo(): void {
    // 請求基本情報取得API呼び出し
    this.usedSzme043aService.searchContractor(this.electricConditionForm.getRawValue(), this.recptFixNoParent, null, null, null, this.cdtmnyNoParent, this.cdtmnyRrknoParent).subscribe(response => {
      console.log(response);
      this.displayFlgSzme043 = true;
    });
  }

  /**
 *  売掛金詳細照会明細APIを呼び出す
 *
 * @memberof UrikakekinElectricComponent
 */
  getElectricDetailUchiwake(): void {
    // 売掛金詳細照会明細API呼び出し
    this.usedSgkd052aService.searchContractor(this.electricConditionForm.getRawValue(),
      this.cdtmnyNoParent, this.cdtmnyRrknoParent).subscribe(response => {
        console.log(response);
        this.displayFlgSzme038 = true;
      });
  };

}